import { useQuery } from "@apollo/client";
import { CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1Document } from "../../../../../../generated";
import { CaseHistory } from "./case-history";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";

export interface CaseHistoryContainerProps {
  caseId: string;
  isCaseOrApplicant: string;
}

export const CaseHistoryContainer: React.FC<CaseHistoryContainerProps> = (
  props
) => {
  const {
    data: caseData,
    loading: caseLoading,
    error: caseError,
  } = useQuery(
    CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1Document,
    {
      variables: {
        sendReportCaseV1Id: props.caseId,
      },
    }
  );

  return (
    <ComponentQueryLoader
      loading={caseLoading}
      error={caseError}
      hasData={caseData}
      hasDataComponent={
        <CaseHistory
          data={caseData?.sendReportCaseV1}
          isCaseOrApplicant={props.isCaseOrApplicant}
        />
      }

    />
  );
};
